export default __webpack_public_path__ + "static/media/submenu_2_off.8367bb65.svg";